import { ChevronLeft } from '@/components/pages/icons';

type StepBackButtonProps = {
  onClick: () => void;
  label: string;
};

export function StepBackButton({ onClick, label }: StepBackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className="flex size-7 shrink-0 cursor-pointer items-center justify-center rounded-md border border-brand-muted-light text-brand-primary transition-colors duration-200 hover:bg-brand-accent/10"
    >
      <ChevronLeft className="size-3.5" />
    </button>
  );
}
